import React from 'react';
import './App.scss';
import { ModalProvider } from './context/ModalContext';
import { ViewProvider } from './context/ViewProvider';
import { LoaderProvider } from './context/LoaderContext';
import MainView from './components/mainView/MainView';
import { LiferayProps } from '.';

const App: React.FC<LiferayProps> = ({properties}) => {
  return (
    <div className='App cr-styles als-vxmc-styles'>
      <ViewProvider>
        <ModalProvider>
          <LoaderProvider>
            <MainView properties={properties}/>
          </LoaderProvider>
        </ModalProvider>
      </ViewProvider>
    </div>
  );
}

export default App;
